import { render, staticRenderFns } from "./channelAvatar.vue?vue&type=template&id=a0110882"
import script from "./channelAvatar.vue?vue&type=script&lang=js"
export * from "./channelAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports